/**
 * we create new hierarchical data
 *
 * @param data hierarchical data
 * @param nodesRef list of nodes to keep or subtract
 * @param prop property to make the checking
 * @param subtract boolean to subtract instead of keep the nodes referenced
 * @returns new node with hierarchical data
 */
export const filterHierarchical: <T extends { children?: Array<T> }>(
  data: T,
  nodesRef: Array<string>,
  prop: string,
  subtract?: boolean
) => T = (data, nodesRef, prop, subtract = false) => {
  if (!nodesRef?.length) {
    return data;
  }

  /*

    Recursive to remove/keep all the nodes referenced
    by default will extract the nodes referenced and if subtract is true
    will delete the node referenced

    Please note that this filter removes only nodes, not descendants
    if a node is remove it descendants will jump one level up
  */

  const buildTree = (children) => children.reduce((collection, child) => {
      // for every child

      if (subtract ? nodesRef.indexOf(child[prop]) === -1 : nodesRef.indexOf(child[prop]) > -1) {
        // if we keep the node, we filter its children
        if (child.children) {
          child.children = buildTree(child.children);
          if (!child.children.length) {
            delete child.children;
          }
        }
        return collection.concat(child);
      } else {
        // if we don't keep the node, we filter its children and bring them UP into THIS collection
        if (child.children) {
          return collection.concat(buildTree(child.children));
        }
        return collection;
      }
    }, []);

  return {
    ...data,
    children: buildTree(data.children)
  };
};
